<template>
  <div class="innerBox">
    <h2 class="mb-4">Daftar Pengecekan Barang Work Order</h2>

	<button
		class="btn btn-info float-right mb-4 mr-2"
		@click="showModal = true"
	>
		+ Tambah Barang
	</button>
	<table class="table text-center">
		<thead class="thead-dark">
			<th>No.</th>
			<th>Nama Barang</th>
			<th>Tempat Ditemukan Barang</th>
			<th>Gambar</th>
			<th colspan="1"><i class="fas fa-cog"></i></th>
		</thead>
		<tbody v-for="(checklist, index) in checklistSettings" :key="index">
			<td>{{index + 1}}</td>
			<td>{{checklist.name.split('_')[1]}}</td>
			<td>{{translatePart(checklist.name.split('_')[0])}}</td>
			<td><img :src="checklist.img ? env.baseImage + '/' + checklist.img : '/img/WorkOrder/Logo/' + checklist.name.split('_')[1] + '.png'" alt="Tidak Ada Gambar" style="width : 70px; height:auto"/></td>
			<td>
				<button class="btn btn-danger" @click="removeChecklistSettings(checklist , checklist.id)">
					<i class="fa fa-times"></i>
				</button>
			</td>
		</tbody>
	</table>

	<NewChecklist
      	v-if="showModal"
		@closeModal="showModal = false"
		@updateTable="this.loadChecklistSettings"
    ></NewChecklist>

  </div>
</template>

<script>
import NewChecklist from './children/newChecklist'
import env from '@/env'

export default {
	components : {
		NewChecklist
	},
	data () {
		return {
			env,
			checklistSettings : null,
			showModal : false
		}
	},
	mounted () {
		this.loadChecklistSettings ()
	},
	methods : {
		loadChecklistSettings () {
			this.checklistSettings = null;
			this.$http.get('/api/v1/workorder/settings')
			.then((resp) => {
				this.checklistSettings = resp.data.data

			})
			.catch((err) => {
				console.log(err)
			})
		},
		removeChecklistSettings(obj , id) {
			this.$http.delete(`/api/v1/workorder/settings/${id}`)
			.then((resp) => {
				this.$store.dispatch('triggerAlert', [true, [`Barang ${obj.name.split('_')[1]} telah berhasil dihapus`]])
				this.loadChecklistSettings()
			})
			.catch((err) => console.log(err))
		},
		translatePart(text) {
			if(text == 'FRONT')
				text = 'Depan'
			else if (text == 'REAR')
				text = 'Belakang'
			else if (text == 'RIGHT')
				text = 'Kanan'
			else if (text == 'LEFT')
				text = 'Kiri'
			else  if (text == 'ATAP')
				text = 'Atap'
			else  if (text == 'INTERIOR')
				text = 'Interior'
			else 
				text = 'Barang Berharga'

			return text
		}
	}
}
</script>
